export const mobileBreakpoint = "800px";

export const Rooms = {
  setup: "setup",
  main: "main",
  fight: "fight",
  training: "training",
  underground: "underground",
  league: "league",
  fuckRoom: "fuckroom",
  leaguePShop: "leaguepointshop",
  loserSlaveRoom: "loserSlaveRoom",
  slaveEventRoom: "slaveEventRoom",
};
export const FightRooms = {
  underground: "underground-pit",
  leagueA: "isekai-ring",
};

export const gender = {
  male: "male",
  female: "female",
  futanari: "futa",
};
export const humanHeight = [
  "petite",
  "small",
  "medium",
  "big",
  "tall",
  "giant",
];
export const bodyShape = {
  petite: "petite",
  small: "small",
  medium: "medium",
  chubby: "chubby",
  buxom: "buxom",
  muscular: "muscular",
};
export const raceType = {
  human: "human",
  dwarf: "dwarf",
  orc: "orc",
  elf: "elf",
  darkelf: "dark elf",
  gnome: "gnome",
  succubus: "succubus",
  fairy: "fairy",
};
export const colors = [
  "black",
  "brown",
  "blonde",
  "auburn",
  "red",
  "white",
  "blue",
  "green",
  "grey",
  "hazel",
];
export const skinColor = [
  "pale",
  "fair",
  "tan",
  "olive",
  "dark",
  "ebony",
  "green",
];
// All sexual organ sizes are from 0-5 (6 in total)
export const PenisSize = ["tiny", "small", "normal", "big", "huge", "massive"];
export const BreastSize = [
  "tiny",
  "small",
  "plump",
  "busty",
  "double d",
  "massive",
];
export const holeSize = [
  "tight",
  "small",
  "snug",
  "stretchy",
  "open",
  "gaping",
];
